import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/a63ba6ef-8d0c-4e7a-b055-c2a32ff3b375/images/fd3bb924c8aed10ad2cb936d43fb4edab82e74e7741187234e25b1cf4f535007.png";

export const Themes = () => {
  const { t } = useLanguage();
  const th = t.themes;

  return (
    <section id="themes" className="relative py-24 md:py-32 overflow-hidden">
      <div
        className="absolute right-0 top-0 h-full w-1/3 bg-cover bg-center opacity-[0.08] pointer-events-none hidden lg:block"
        style={{ backgroundImage: `url(${TEXTURE})` }}
      />
      <div className="container-page relative">
        <Reveal className="max-w-3xl">
          <span className="overline text-[#CEA26B]">{th.overline}</span>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {th.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-white/10">
          {th.items.map((item, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <div
                data-testid={`theme-block-${i}`}
                className="group relative h-full border-r border-b border-white/10 p-8 md:p-10 hover:bg-white/[0.03] transition-colors duration-300"
              >
                <span className="font-display text-5xl font-black text-white/10 group-hover:text-[#CEA26B]/40 transition-colors">
                  {item.num}
                </span>
                <h3 className="mt-5 font-display font-bold text-white text-xl leading-snug">{item.title}</h3>
                <div className="mt-3 space-y-2.5">
                  {item.descs.map((d, di) => (
                    <p key={di} className="text-sm text-slate-400 leading-relaxed">{d}</p>
                  ))}
                </div>
                <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-[#CEA26B] group-hover:w-full transition-all duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
